"use strict";

exports.__esModule = true;
exports.LogbookTicketDetails = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _icons = require("@blueprintjs/icons");
var _reactFinalForm = require("react-final-form");
var _polished = require("polished");
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _FormGroupField = require("../../Form/FormGroupField");
var _Time = require("../../Time");
var _Core = require("../../Core");
var _Theme = require("../../Theme");
var _LogbookItemDescription = require("../LogbookItems/LogbookItemDescription");
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var NewEventHeader = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicketDetails__NewEventHeader",
  componentId: "sc-16rsggk-0"
})(["background:", ";display:flex;justify-content:space-between;align-items:center;padding:0 0.8rem;height:48px;border-top:1px solid ", ";border-bottom:1px solid ", ";"], (0, _Theme.val)("LogBookNewEventBackground"), (0, _Theme.val)("LogbookBorderColor"), (0, _Theme.val)("LogbookBorderColor"));
var LogbookHeading = (0, _styledComponents["default"])(_Core.Heading).withConfig({
  displayName: "LogbookTicketDetails__LogbookHeading",
  componentId: "sc-16rsggk-1"
})(["padding:0;margin:0;"]);
var DetailsHeading = (0, _styledComponents["default"])(_Core.Heading).withConfig({
  displayName: "LogbookTicketDetails__DetailsHeading",
  componentId: "sc-16rsggk-2"
})(["margin:0 0 0.3rem;"]);
var AssigneeHeading = (0, _styledComponents["default"])(_Core.Heading).withConfig({
  displayName: "LogbookTicketDetails__AssigneeHeading",
  componentId: "sc-16rsggk-3"
})(["margin:0;"]);
var Body = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicketDetails__Body",
  componentId: "sc-16rsggk-4"
})(["overflow:hidden;font-size:", ";margin-bottom:0.3rem;padding:0.8rem 0.8rem 0;background:", ";& .", ".", ".", "{color:", ";}"], (0, _Theme.val)("fontSizeSmall"), (0, _Theme.val)("LogBookNewEventBackground"), _core.Classes.BUTTON, _core.Classes.MINIMAL, _core.Classes.INTENT_PRIMARY, (0, _Theme.val)("minimalButtonText"));
var Content = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicketDetails__Content",
  componentId: "sc-16rsggk-5"
})(["font-size:14px;"]);
var InfoRow = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicketDetails__InfoRow",
  componentId: "sc-16rsggk-6"
})(["display:flex;justify-content:space-between;margin-bottom:0.8rem;align-items:center;font-size:", ";"], (0, _Theme.val)("fontSizeXS"));
var TicketDetailTag = (0, _styledComponents["default"])(_core.Tag).withConfig({
  displayName: "LogbookTicketDetails__TicketDetailTag",
  componentId: "sc-16rsggk-7"
})(["margin:0 0.3rem 0.3rem 0;"]);
var Row = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicketDetails__Row",
  componentId: "sc-16rsggk-8"
})(["display:flex;justify-content:flex-start;flex-wrap:wrap;margin-bottom:0.8rem;align-items:center;font-size:", ";"], (0, _Theme.val)("fontSizeXS"));
var CommentsRow = (0, _styledComponents["default"])(Row).withConfig({
  displayName: "LogbookTicketDetails__CommentsRow",
  componentId: "sc-16rsggk-9"
})(["display:flex;flex-direction:column;margin-bottom:0;align-items:flex-start;"]);
var IconRightMargin = (0, _styledComponents["default"])(_core.Icon).withConfig({
  displayName: "LogbookTicketDetails__IconRightMargin",
  componentId: "sc-16rsggk-10"
})(["margin-right:0.2rem;"]);
var CreatedWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicketDetails__CreatedWrapper",
  componentId: "sc-16rsggk-11"
})(["display:flex;align-items:center;line-height:1.1rem;font-size:", ";font-weight:400;color:", ";"], (0, _Theme.val)("fontSizeXS"), function (props) {
  return props.theme.LogbookMutedTextColor;
});
var UserWrapper = (0, _styledComponents["default"])(CreatedWrapper).withConfig({
  displayName: "LogbookTicketDetails__UserWrapper",
  componentId: "sc-16rsggk-12"
})([""]);
var CommentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "LogbookTicketDetails__CommentWrapper",
  componentId: "sc-16rsggk-13"
})(["display:flex;flex:1;justify-content:flex-start;align-items:center;width:100%;border-bottom:1px solid ", ";padding:0.5rem 0;"], (0, _Theme.val)("LogbookBorderColor"));
var LogbookTicketDetails = exports.LogbookTicketDetails = /*#__PURE__*/function (_Component) {
  function LogbookTicketDetails() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.validateComment = function (value) {
      if (!value || !value.trim()) {
        return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "NewLogbookComment.commentError",
          defaultMessage: "Comment is required."
        });
      }
    };
    _this.validateDevices = function (value) {
      if (!Array.isArray(value) || value.length === 0) {
        return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "NewLogbookComment.deviceError",
          defaultMessage: "Device is required."
        });
      }
    };
    _this.handleSubmit = function (values) {
      var onSubmit = _this.props.onSubmit;
      return onSubmit(values.comment);
    };
    return _this;
  }
  _inheritsLoose(LogbookTicketDetails, _Component);
  var _proto = LogbookTicketDetails.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      ticket = _this$props.ticket,
      closeDetails = _this$props.closeDetails,
      onStatusClick = _this$props.onStatusClick,
      onAssignClick = _this$props.onAssignClick;
    if (!ticket) return null;
    var tags = ticket.tags,
      watchers = ticket.watchers,
      created = ticket.created,
      id = ticket.id,
      types = ticket.types,
      comments = ticket.comments,
      title = ticket.title,
      creator = ticket.creator,
      status = ticket.status,
      assignee = ticket.assignee,
      devices = ticket.devices,
      userId = ticket.userId,
      assigneeId = ticket.assigneeId;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(NewEventHeader, null, /*#__PURE__*/_react["default"].createElement(LogbookHeading, {
      level: "4"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.ticket",
      defaultMessage: "Ticket"
    }), " #" + id), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      minimal: true,
      icon: _icons.IconNames.CROSS,
      onClick: closeDetails
    })), /*#__PURE__*/_react["default"].createElement(Body, null, /*#__PURE__*/_react["default"].createElement(InfoRow, null, /*#__PURE__*/_react["default"].createElement(UserWrapper, null, /*#__PURE__*/_react["default"].createElement(IconRightMargin, {
      icon: _icons.IconNames.USER
    }), " ", creator), /*#__PURE__*/_react["default"].createElement(CreatedWrapper, null, /*#__PURE__*/_react["default"].createElement(_Time.FormattedPlantDate, {
      formatOptions: {
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      },
      value: created
    }))), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(Content, null, title)), /*#__PURE__*/_react["default"].createElement(DetailsHeading, {
      level: "6"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.status",
      defaultMessage: "Status"
    })), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: function onClick() {
        return onStatusClick(_constants.TICKET_STATUS_OPEN);
      },
      active: status === _constants.TICKET_STATUS_OPEN
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.openButton",
      defaultMessage: "Open"
    })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: function onClick() {
        return onStatusClick(_constants.TICKET_STATUS_IN_PROGRESS);
      },
      active: status === _constants.TICKET_STATUS_IN_PROGRESS
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.inProgressButton",
      defaultMessage: "In Progress"
    })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: function onClick() {
        return onStatusClick(_constants.TICKET_STATUS_CLOSED);
      },
      active: status === _constants.TICKET_STATUS_CLOSED
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.closedButton",
      defaultMessage: "Closed"
    })))), /*#__PURE__*/_react["default"].createElement(AssigneeHeading, {
      level: "6"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.assignee",
      defaultMessage: "Assignee"
    })), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement("div", null, assignee), userId !== assigneeId && /*#__PURE__*/_react["default"].createElement(_core.Button, {
      onClick: onAssignClick,
      intent: _core.Intent.PRIMARY,
      minimal: true
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.assigneeButton",
      defaultMessage: "Assign to me"
    }))), /*#__PURE__*/_react["default"].createElement(DetailsHeading, {
      level: "6"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.types",
      defaultMessage: "Types"
    })), /*#__PURE__*/_react["default"].createElement(Row, null, types.map(function (type) {
      return /*#__PURE__*/_react["default"].createElement(TicketDetailTag, {
        style: {
          backgroundColor: type.color,
          color: (0, _polished.readableColor)(type.color)
        },
        key: type.id
      }, type.value);
    })), /*#__PURE__*/_react["default"].createElement(DetailsHeading, {
      level: "6"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.watchersLabel",
      defaultMessage: "Watchers"
    })), /*#__PURE__*/_react["default"].createElement(Row, null, watchers.join(",  ")), /*#__PURE__*/_react["default"].createElement(DetailsHeading, {
      level: "6"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.devicesLabel",
      defaultMessage: "Devices"
    })), /*#__PURE__*/_react["default"].createElement(Row, null, devices.join(", ")), /*#__PURE__*/_react["default"].createElement(DetailsHeading, {
      level: "6"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.deviceGroupsLabel",
      defaultMessage: "Device Groups"
    })), /*#__PURE__*/_react["default"].createElement(Row, null, tags.map(function (tag) {
      return /*#__PURE__*/_react["default"].createElement(TicketDetailTag, {
        key: tag
      }, tag);
    })), /*#__PURE__*/_react["default"].createElement(Row, null, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
      onSubmit: this.handleSubmit
    }, function (_ref) {
      var form = _ref.form,
        handleSubmit = _ref.handleSubmit,
        pristine = _ref.pristine,
        invalid = _ref.invalid,
        submitting = _ref.submitting;
      return /*#__PURE__*/_react["default"].createElement("form", {
        style: {
          width: "100%"
        },
        onSubmit: (/*#__PURE__*/function () {
          var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(event) {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return handleSubmit(event);
                case 1:
                  form.reset();
                  form.resetFieldState("comment");
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref2.apply(this, arguments);
          };
        }())
      }, /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
        name: "comment",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "LogbookTicketDetails.comment",
          defaultMessage: "Add Comment"
        }),
        validate: _this2.validateComment
      }, function (_ref3) {
        var input = _ref3.input;
        return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
          fill: true,
          style: {
            height: "100px"
          }
        }, input));
      }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
        type: "submit",
        intent: _core.Intent.PRIMARY,
        loading: submitting,
        text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "LogbookTicketDetails.create.button.comment",
          defaultMessage: "Create Comment"
        }),
        disabled: pristine || invalid
      }));
    })), /*#__PURE__*/_react["default"].createElement(DetailsHeading, {
      level: "6"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "LogbookTicketDetails.commentsLabel",
      defaultMessage: "Comments"
    })), comments && /*#__PURE__*/_react["default"].createElement(CommentsRow, null, comments.map(function (comment) {
      return /*#__PURE__*/_react["default"].createElement(CommentWrapper, {
        key: comment.id
      }, /*#__PURE__*/_react["default"].createElement(_LogbookItemDescription.LogbookItemDescription, {
        title: comment.body,
        creator: comment.creator,
        created: comment.created
      }));
    }))));
  };
  return LogbookTicketDetails;
}(_react.Component);
LogbookTicketDetails.defaultProps = {
  translator: undefined
};